import { Injectable } from "@angular/core";
import { Storage } from '@ionic/storage';

@Injectable()
export class FilterDataService {

  constructor(
    private storage: Storage) {
  }

  // Note!!!
  // Kalau Array isi contoh key : [1].data.updatedStartTimeISO
  // kalau Array Object isi contoh key : data2[0].updatedStartTimeISO / [0].data2[0].updatedStartTimeISO
  // kalau Object isi contoh key : data.updatedStartTimeISO
  //

  /**
   * USE IN HTML or not need await
   * */
  filter(key: any, data: any) {
    let hasHave: any;
    try {
      if (eval("data").constructor.name == "Array") {
        hasHave = eval("data" + key);
      } else {
        hasHave = eval("data" + "." + key);
      }
      return hasHave;
    } catch (error) {
      return key;
    }
  }


  /**
   * USE IN TS IF NEED AWAIT
   * */
  async asyncFilter(key: any, dataValue: any, auth?: boolean) {
    if (auth) {
      const SFGoAuth = JSON.parse(await this.storage.get('SFGoAuth'));
      console.log('data auth filter', SFGoAuth)
      return await this.evalData(key, SFGoAuth)
    } else {
      return await this.evalData(key, dataValue);
    }
  }


  /**
   this is filter data to return data array object and return filterDataObject
   data must be : [
   {
       paramsKey : string, // params key to return key
       paramsValue: string, // params key to find from value
       getFromAuth: boolean // condition if data find in auth
    } ]
   */
  async filterDataObject(arrayObject: any, value: any) {
    const dataReturn = {}/**/
    for (let i = 0; i < arrayObject.length; i++) {
      dataReturn[arrayObject[i].paramsKey] = await this.asyncFilter(arrayObject[i].paramsValue, value, arrayObject[i].getFromAuth ? arrayObject[i].getFromAuth : false)
    }
    console.log(dataReturn)
    return dataReturn
  }

  /**
   this is filter data to return data array object and return filterDataObject
   data must be : [
   {
       paramKey : string, // params key to return key
       paramValue: string, // params key to find from value
       getFromAuth: boolean // condition if data find in auth
    } ]
   */
  async filterDataObjectV2(arrayObject: any, value: any) {
    const dataReturn = {}/**/
    for (let i = 0; i < arrayObject.length; i++) {
      dataReturn[arrayObject[i].paramKey] = await this.asyncFilter(arrayObject[i].paramValue, value, arrayObject[i].getFromAuth ? arrayObject[i].getFromAuth : false)
    }
    console.log(dataReturn)
    return dataReturn
  }


  async evalData(key: any, value) {
    let hasHave: any;
    return new Promise((resolve, reject) => {
      try {
        if (eval("value").constructor.name == "Array") {
          hasHave = eval("value" + key);
        } else {
          hasHave = eval("value" + "." + key);
        }
        resolve(hasHave);
      } catch (error) {
        resolve(key);
      }
    })
  }

  async urlParamGenerator(data) {
    return new Promise(resolve => {
      var str = "";
      for (var key in data) {
        if (str != "") {
          str += "&";
        }
        str += key + "=" + encodeURIComponent(data[key]);
      }
      resolve(str)
    })
  }

  /**
   * change array object with paramKey, paramValue to Object
   * */
  keyValueToObject(data) {
    const val = {}
    for(let item of data){
      val[item.paramKey] = item.paramValue
    }
    return val
  }


}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/helper/filter-data.service.ts